import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import apiRoutes from '../api/apiRoutes';

export const ExploreContext = createContext();

export const ExploreProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarData, setSidebarData] = useState(null);
  const [appsByUser, setAppsByUser] = useState(null);


  const saveAppData = async (appData) => {
    try {
      const response = await axios.post(apiRoutes.apps.saveApp, appData);
      return response.data;
    } catch (error) {
      console.error('Error saving app data:', error.response ? error.response.data : error.message);
      throw error;
    }
  };

  const saveParentAppData = async (appData) => {
    try {
      let formData = new FormData();

      Object.entries(appData).forEach(([key, value]) => {
        if (key === 'thumbnail' || key === 'preview_img') {

          formData.append(key, value);
        } else {
          formData.append(key, value);
        }
      });

      // Enviar al backend
      const response = await axios.post(apiRoutes.apps.saveParenApp, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error saving app data:', error.response ? error.response.data : error.message);
      throw error;
    }
  };

  const getAllApps = async (oktaId) => {
    try {
      const response = await axios.get(apiRoutes.apps.getAllApps(oktaId));
      return response.data.data;

    } catch (err) {
      return err
    }
  }
  const getAllAdminApps = async (oktaId, page = 1, searchTerm = '') => {
    try {
      const params = { okta_id: oktaId, page, limit: 10, searchTerm };
      const response = await axios.post(apiRoutes.apps.adminapps, { params });
      return response.data;
    } catch (err) {
      return err;
    }
  };
  const getAdminParentApps = async (oktaId) => {
    try {
      const params = { okta_id: oktaId };
      const response = await axios.post(apiRoutes.apps.parentapps, {
        params: params
      });
      return response.data.data;

    } catch (err) {
      return err
    }
  }
  const getAppsPA = async (oktaId) => {
    try {
      const response = await axios.get(apiRoutes.apps.getAppsPA(oktaId));
      return response.data.data;

    } catch (err) {
      return err
    }
  }
  const getExploreApps = async (oktaId) => {
    try {
      const response = await axios.get(apiRoutes.apps.getAllApps, {
        params: {
          okta_id: oktaId
        }
      });
      return response.data;

    } catch (err) {
      return err
    }
  }
  const getAppsByUser = async (userId, adminId) => {
    try {
      const params = { userId: userId };

      // Añadir adminId a los parámetros solo si existe
      if (adminId) {
        params.adminId = adminId;
      }

      const response = await axios.post(apiRoutes.apps.getAppsByUser, {
        params: params
      });
      setAppsByUser(response.data);
    } catch (err) {
      return err;
    }
  };

  const createFavorite = async (oktaId, appId, adminId = null) => {
    try {
      const payload = {
        okta_id: oktaId,
        app_id: appId
      };

      // Añadir adminId al payload si está presente
      if (adminId) {
        payload.admin_id = adminId;
      }

      const response = await axios.post(apiRoutes.favorites.toggle, payload);

      return response.data;
    } catch (error) {
      console.error('Error creating favorite:', error.response ? error.response.data : error.message);
    }
  };
  const deleteFavorite = async (oktaId, appId, adminId = null) => {
    try {
      const payload = {
        okta_id: oktaId,
        app_id: appId
      };

      // Añadir adminId al payload si está presente
      if (adminId) {
        payload.admin_id = adminId;
      }

      const response = await axios.delete(apiRoutes.favorites.toggle, {
        data: payload
      });

      return response.data;
    } catch (error) {
      console.error('Error deleting favorite:', error.response ? error.response.data : error.message);
    }
  };
  const getSidebar = async (userId) => {
    try {
      const params = { userId: userId };
      const response = await axios.post(apiRoutes.apps.sidebar, {
        params: params
      });
      setSidebarData(response.data.data);

    } catch (err) {
      return err
    }
  }



  const searchParentAppsAndApps = async (value) => {
    try {
      const response = await axios.get(`${apiRoutes.apps.searchPAApps}?searchTerm=${encodeURIComponent(value)}`);
      return response.data.data;

    } catch (err) {
      return err
    }
  }

  const searchAccounts = async (searchTerm) => {
    try {
      const response = await axios.get(`${apiRoutes.account.search}`, {
        params: { query: searchTerm },
      });
      return response.data;

    } catch (err) {
      return err
    }
  }



  return (
    <ExploreContext.Provider
      value={{
        getAllApps,
        getAllAdminApps,
        getAdminParentApps,
        getAppsByUser,
        appsByUser,
        createFavorite,
        deleteFavorite,
        getSidebar,
        sidebarData,
        saveAppData,
        saveParentAppData,
        getAppsPA,
        searchParentAppsAndApps,
        searchAccounts,
      }}>
      {children}
    </ExploreContext.Provider>
  );
};
